import { Caption } from '@design-systems/canvas-ui'
import '../css/Footer.css'
import '../css/common.css'

function Copyright() {
  return (
    <div className="footer-content">
      <Caption
        color="textSecondary"
        align="center"
        className="footer-copyright"
      >
        {' © '}
        Target Brands, Inc.
        <br />
        The Bullseye Design is a registered trademark of Target Brands, Inc.
      </Caption>
    </div>
  )
}

export default function StickyFooter() {
  return (
    <div className="footer-container">
      {/* Show footer on desktop, hidden on mobile via CSS */}
      <footer>
        <Copyright />
      </footer>
    </div>
  )
}
